// extracted by mini-css-extract-plugin
export default {"form":"ResetAccountPage_form__pM5L7","heading":"ResetAccountPage_heading__ze92G","head":"ResetAccountPage_head__QsoBb"};